import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

class CRUD{

    initialState = {
        isLoading: false,
        error: null,
        items: {data: []},
        allItems: [],
        item: null,
    };

    name = null
    scope = null
    sliceName = null
    slice = null

    reducers = {
        startLoading(state) {
            state.isLoading = true;
        },

        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        getItemsSuccess(state, action) {
            state.isLoading = false;
            state.items = action.payload;
        },

        getAllItemsSuccess(state, action) {
            state.isLoading = false;
            state.allItems = action.payload;
        },

        getItemSuccess(state, action) {
            state.isLoading = false;
            state.item = action.payload;
        },

        saveItemSuccess(state, action) {
            state.isLoading = false;
        },

        deleteItemSuccess(state, action) {
            state.isLoading = false;
        },

        uploadSuccess(state, action) {
            state.isLoading = false;
        },
    }

    constructor(name, scope, sliceName = null) {
        this.name = name
        this.scope = scope
        this.sliceName = sliceName || name
        this.createSlice()
    }

    getReducer(){
        return this.slice.reducer
    }

    createSlice(){
        this.slice = createSlice({
            name: this.sliceName,
            initialState: this.initialState,
            reducers: this.reducers
        });
    }

    getItems(page=1, perPage=10, filters={}) {
        return async (dispatch) => {
            dispatch(this.slice.actions.startLoading());
            try {
                const response = await axios.get(`/${this.scope}/${this.name}`, {
                    params: {
                        'page': page,
                        'limit': perPage,
                        'filters': filters
                    }
                });
                return dispatch(this.slice.actions.getItemsSuccess(response.data));
            } catch (error) {
                dispatch(this.slice.actions.hasError(error));
            }
        };
    }

    getAllItems(filters = {}) {
        return async (dispatch) => {
            try {
                const response = await axios.get(`/${this.scope}/${this.name}`, {
                    params: {
                        'filters': filters
                    }
                });
                return dispatch(this.slice.actions.getAllItemsSuccess(response.data));
            } catch (error) {
                dispatch(this.slice.actions.hasError(error));
            }
        };
    }

    getItem(id) {
        return async (dispatch) => {
            dispatch(this.slice.actions.startLoading());
            try {
                const response = await axios.get(`/${this.scope}/${this.name}/${id}`);
                dispatch(this.slice.actions.getItemSuccess(response.data));
            } catch (error) {
                console.error(error);
                dispatch(this.slice.actions.hasError(error));
            }
        };
    }


    deleteItem(id) {
        return async (dispatch) => {
            dispatch(this.slice.actions.startLoading());
            try {
                const response = await axios.delete(`/${this.scope}/${this.name}/${id}`)
                return dispatch(this.slice.actions.deleteItemSuccess(response.data));
            } catch (error) {
                console.error(error);
                return dispatch(this.slice.actions.hasError(error));
            }
        };
    }

    saveItem(item, config={}) {
        return async (dispatch) => {
            dispatch(this.slice.actions.startLoading());
            try {
                const response = await axios.post(`/${this.scope}/${this.name}`, item, config)
                return dispatch(this.slice.actions.saveItemSuccess(response.data));
            } catch (error) {
                console.error(error);
                return dispatch(this.slice.actions.hasError(error));
            }
        };
    }

    uploadField(id, field, data){
        return async (dispatch) => {
            try {
                return axios.post(`/${this.scope}/${this.name}/${id}/upload/${field}`, data, {headers: {
                    'Content-Type': 'multipart/form-data'
                }})
            } catch (error) {
                console.error(error);
            }
        };
    }

    upload(file, additional, config={}) {
        return async (dispatch) => {
            dispatch(this.slice.actions.startLoading());
            try {
                const formData = new FormData();
                formData.append('file', file)
                for(const a of additional){
                    formData.append(a.name, a.value)
                }

                const response = await axios.post(`/${this.scope}/${this.name}/upload`, formData, {...config, headers: {
                    'Content-Type': 'multipart/form-data'
                }})
                return dispatch(this.slice.actions.uploadSuccess(response.data));
            } catch (error) {
                console.error(error);
                return dispatch(this.slice.actions.hasError(error));
            }
        };
    }
}


export default CRUD
